import {
  AccountHierarchyResponseTypeEnum,
  MCustomSelectProps,
} from '@monetize/types/app';
import React, { useMemo, useState } from 'react';
import { useGetAccountHierarchyById } from '../../api/accountsService';
import { renderItemContentForAccountHierarchy } from '../../routes/Settings/rules-v3/rules.utils';
import { convertNestedAccountHierarchyToList } from '../../utils/account';
import { MainSearchInput } from '../Monetize/MCustomSelect/components/MainSearchInput';
import { MCustomSelect } from '../Monetize/MCustomSelect/MCustomSelect';

interface AccountHierarchySelectProps extends MCustomSelectProps {
  onClearAccountValue?: () => void;
  /** MCustomSelect here emits the item value (id string), not the full item */
  onChange: (accountId: string) => void;

  rootAccountId: string;
}

export const AccountHierarchySelect = React.forwardRef<
  any,
  AccountHierarchySelectProps
>(
  (
    {
      onClearAccountValue,
      onChange,
      rootAccountId,
      ...rest
    }: AccountHierarchySelectProps,
    ref,
  ) => {
    const { data: accountHierarchyResponse } = useGetAccountHierarchyById(
      rootAccountId,
      AccountHierarchyResponseTypeEnum.NESTED,
      {
        enabled: !!rootAccountId,
      },
    );

    const [query, setQuery] = useState('');

    const accounts = useMemo(() => {
      if (!accountHierarchyResponse) {
        return [];
      }
      const accountConvertedList = convertNestedAccountHierarchyToList(
        accountHierarchyResponse,
      );
      if (!query.trim()) {
        return accountConvertedList;
      }
      return accountConvertedList.filter((account) =>
        account.name.toLowerCase().includes(query.toLowerCase()),
      );
    }, [accountHierarchyResponse, query]);

    return (
      <MCustomSelect
        ref={ref}
        clearable
        items={accounts}
        useExternalQuery
        externalQuery={query}
        onChangeQuery={setQuery}
        onClear={onClearAccountValue}
        itemTitle="name"
        itemValue="id"
        useMainInputAsSearchInput
        MainInputComponent={MainSearchInput}
        renderItemContent={renderItemContentForAccountHierarchy}
        onChange={onChange}
        isSelectOpen={false}
        {...rest}
      />
    );
  },
);
